export type ParsedInterestRate = { kind: "empty" } | { kind: "rate"; fraction: number } | { kind: "notANumber" };

const plainDecimal = /^-?(\d+([.,]\d*)?|[.,]\d+)$/;

export const parseInterestRateInput = (text: string): ParsedInterestRate => {
  const percent = text.trim().replace(/\s*%$/, "");
  if (percent === "") return { kind: "empty" };
  if (!plainDecimal.test(percent)) return { kind: "notANumber" };
  return { kind: "rate", fraction: Number.parseFloat(percent.replace(",", ".")) / 100 };
};
